import React, { useState } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink } from "react-router-dom";

const TEAL = "#06b6a4";
const BLUE = "#0ea5e9";
const BLUE_DARK = "#0284c7";

const ASSET_TABS = [
  { key: "mutual_fund", label: "Mutual Fund" },
  { key: "share_bond", label: "Share & Bond" },
  { key: "fixed_deposit", label: "Fixed Deposit" },
  { key: "other_assets", label: "Other Assets" },
];

const MF_COLUMNS = [
  { key: "date", label: "Date", sort: true, highlight: true },
  { key: "scheme_name", label: "Scheme Name", sort: true, search: true },
  { key: "folio", label: "Folio", sort: true, search: true },
  { key: "applicant", label: "Applicant", sort: true },
  { key: "transaction_type", label: "Transaction Type", filter: true },
  { key: "units", label: "Units", sort: true },
  { key: "price", label: "Price (₹)", sort: true },
  { key: "amount", label: "Amount (₹)", sort: true },
  { key: "stamp_duty", label: "Stamp Duty", sort: true },
  { key: "tds", label: "TDS", sort: true },
  { key: "stt", label: "STT", sort: true },
  { key: "total", label: "Total", sort: true },
];

const SHARE_BOND_COLUMNS = [
  { key: "date", label: "Date", sort: true, highlight: true },
  { key: "investor_name", label: "Investor Name", sort: true },
  { key: "scrip_name", label: "Scrip Name", sort: true },
  { key: "transaction_type", label: "Transaction Type", filter: true },
  { key: "unit", label: "Unit", sort: true },
  { key: "price", label: "Price (₹)", sort: true },
  { key: "amount", label: "Amount (₹)", sort: true },
];

const FD_COLUMNS = [
  { key: "allotment_date", label: "Allotment Date", sort: true, highlight: true },
  { key: "investor_name", label: "Investor Name", sort: true },
  { key: "scheme", label: "Scheme", sort: true },
  { key: "period", label: "Period", sort: true },
  { key: "maturity_date", label: "Maturity Date", sort: true },
  { key: "amount", label: "Amount", sort: true },
  { key: "actions", label: "Actions" },
];

const OTHER_ASSETS_COLUMNS = [
  { key: "date", label: "Date", sort: true, highlight: true },
  { key: "investor_name", label: "Investor Name", sort: true, search: true },
  { key: "asset_type", label: "Asset Type", sort: true, search: true },
  { key: "asset_name", label: "Asset Name", sort: true, search: true },
  { key: "transaction_type", label: "Transaction Type", sort: true, search: true },
  { key: "amount", label: "Amount", sort: true },
];

function ThCell({ col }) {
  return (
    <th
      style={{
        padding: "14px 20px",
        color: col.highlight ? "#0f172a" : "#475569",
        fontWeight: "600",
        fontSize: "13px",
        whiteSpace: "nowrap",
        background: "#f8fafc",
        borderBottom: "1px solid #e2e8f0",
        borderLeft: col.highlight ? `4px solid ${TEAL}` : undefined,
        verticalAlign: "middle",
      }}
    >
      {col.label}
      {(col.sort || col.search || col.filter) && (
        <span className="ms-1 opacity-75">
          {col.sort && <i className="fa fa-sort" style={{ fontSize: "10px" }} aria-hidden />}
          {col.search && <i className="fa fa-search ms-1" style={{ fontSize: "10px" }} aria-hidden />}
          {col.filter && !col.search && <i className="fa fa-filter ms-1" style={{ fontSize: "10px" }} aria-hidden />}
        </span>
      )}
    </th>
  );
}

export default function Transactions() {
  const [assetTab, setAssetTab] = useState("mutual_fund");
  const [subCategory, setSubCategory] = useState("");
  const [searchScrip, setSearchScrip] = useState("");
  const [dateFrom, setDateFrom] = useState("2026-01-12");
  const [dateTo, setDateTo] = useState("2026-02-12");
  const [fdToggle, setFdToggle] = useState("running");
  const [viewMode, setViewMode] = useState("transaction");
  const [selectedTxn, setSelectedTxn] = useState(null);

  const getColumns = () => {
    switch (assetTab) {
      case "mutual_fund": return MF_COLUMNS;
      case "share_bond": return SHARE_BOND_COLUMNS;
      case "fixed_deposit": return FD_COLUMNS;
      case "other_assets": return OTHER_ASSETS_COLUMNS;
      default: return MF_COLUMNS;
    }
  };

  const columns = getColumns();
  const hasData = false;

  const handleExportXls = () => { };

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9", minHeight: "100vh", paddingBottom: "2rem" }}>
        {/* Page header */}
        <div className="card border-0 mb-4" style={{ borderRadius: "12px", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
          <div className="card-body px-4 py-3">
            <h3 className="mb-2 text-primary">Transactions</h3>
            <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none" }}>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <NavLink to="/overview">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/clientmutualfunds">Mutual Funds</NavLink> /
                </li>
                <li className="breadcrumb-item active">Transactions</li>
              </ol>
            </nav> 
          </div>
        </div>

        {/* Main card */}
        <div className="card border-0" style={{ borderRadius: "12px", boxShadow: "0 1px 3px rgba(0,0,0,0.06)", overflow: "hidden" }}>
          {/* Filters row */}
          <div style={{ padding: "20px 24px", background: "#fff", borderBottom: "1px solid #e2e8f0" }}>
            <div className="d-flex flex-wrap align-items-end gap-4">
              {assetTab === "mutual_fund" && (
                <div>
                  <label className="form-label mb-1" style={{ fontSize: "0.8125rem", color: "#64748b", fontWeight: "500" }}>Sub Category</label>
                  <select
                    className="form-select form-select-sm"
                    value={subCategory}
                    onChange={(e) => setSubCategory(e.target.value)}
                    style={{ width: "160px", borderRadius: "8px", border: "1px solid #cbd5e1", height: "38px" }}
                  >
                    <option value="">Select</option>
                  </select>
                </div>
              )}
              {assetTab === "share_bond" && (
                <div>
                  <label className="form-label mb-1" style={{ fontSize: "0.8125rem", color: "#64748b", fontWeight: "500" }}>Search Scrip</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Search Scrip"
                    value={searchScrip}
                    onChange={(e) => setSearchScrip(e.target.value)}
                    style={{ width: "180px", borderRadius: "8px", border: "1px solid #cbd5e1", height: "38px" }}
                  />
                </div>
              )}
              {assetTab === "fixed_deposit" && (
                <div className="d-flex align-items-center gap-2" style={{ paddingBottom: "2px" }}>
                  <span style={{ fontSize: "0.875rem", color: "#64748b", fontWeight: fdToggle === "running" ? "600" : "400" }}>Running</span>
                  <div className="form-check form-switch mb-0">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={fdToggle === "matured"}
                      onChange={() => setFdToggle(fdToggle === "running" ? "matured" : "running")}
                      style={{ width: 40, height: 20, accentColor: TEAL, cursor: "pointer" }}
                    />
                  </div>
                  <span style={{ fontSize: "0.875rem", color: "#64748b", fontWeight: fdToggle === "matured" ? "600" : "400" }}>Matured</span>
                </div>
              )}
              {assetTab === "other_assets" && (
                <div className="d-flex align-items-center gap-2" style={{ paddingBottom: "2px" }}>
                  <span style={{ fontSize: "0.875rem", color: "#64748b", fontWeight: viewMode === "current_value" ? "600" : "400" }}>Current value</span>
                  <div className="form-check form-switch mb-0">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={viewMode === "transaction"}
                      onChange={() => setViewMode(viewMode === "current_value" ? "transaction" : "current_value")}
                      style={{ width: 40, height: 20, accentColor: TEAL, cursor: "pointer" }}
                    />
                  </div>
                  <span style={{ fontSize: "0.875rem", color: "#64748b", fontWeight: viewMode === "transaction" ? "600" : "400" }}>Transaction</span>
                </div>
              )}
              <div>
                <label className="form-label mb-1" style={{ fontSize: "0.8125rem", color: "#64748b", fontWeight: "500" }}>Date Range</label>
                <div className="d-flex align-items-center gap-2">
                  <div className="input-group input-group-sm" style={{ width: "auto" }}>
                
                    <input
                      type="date"
                      className="form-control"
                      value={dateFrom}
                      onChange={(e) => setDateFrom(e.target.value)}
               
                    />
                  </div>
                  <span style={{ color: "#94a3b8", fontWeight: "500" }}>–</span>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    value={dateTo}
                    onChange={(e) => setDateTo(e.target.value)}
                    
                  />
                </div>
              </div>
              <div className="ms-auto">
                <button
                  type="button"
                  className="btn btn-sm d-flex align-items-center gap-2 px-3"
                  style={{
                    background: TEAL,
                    color: "#fff",
                    border: "none",
                    borderRadius: "8px",
                    fontWeight: "600",
                    height: "38px",
                    fontSize: "0.875rem",
                  }}
                >
                  <i className="fa fa-user" style={{ fontSize: "0.875rem" }} aria-hidden />
                  Select User
                  <i className="fa fa-chevron-down" style={{ fontSize: "0.7rem" }} aria-hidden />
                </button>
              </div>
            </div>
          </div>

          {/* Tabs + actions */}
          <div className="d-flex flex-wrap align-items-stretch" style={{ background: BLUE, padding: "0 24px", minHeight: "48px" }}>
            <div className="d-flex">
              {ASSET_TABS.map((tab) => (
                <button
                  key={tab.key}
                  type="button"
                  className="btn d-flex align-items-center px-4 py-3 border-0 rounded-0"
                  style={{
                    background: assetTab === tab.key ? "rgba(255,255,255,0.15)" : "transparent",
                    color: "#fff",
                    fontWeight: "600",
                    fontSize: "0.875rem",
                    borderLeft: assetTab === tab.key ? `4px solid ${TEAL}` : "4px solid transparent",
                    borderRadius: 0,
                  }}
                  onClick={() => setAssetTab(tab.key)}
                >
                  {tab.label}
                </button>
              ))}
            </div>
            <div className="d-flex align-items-center gap-2 ms-auto py-2">
              <button
                type="button"
                className="btn btn-sm px-3 d-flex align-items-center gap-2"
                style={{
                  background: TEAL,
                  color: "#fff",
                  border: "none",
                  borderRadius: "8px",
                  fontWeight: "600",
                  height: "36px",
                  fontSize: "0.8125rem",
                }}
              >
                Add Transaction
              </button>
              <button
                type="button"
                className="btn btn-sm px-3 d-flex align-items-center gap-2"
                onClick={handleExportXls}
                title="Export Excel"
                style={{
                  background: BLUE_DARK,
                  color: "#fff",
                  border: "none",
                  borderRadius: "8px",
                  fontWeight: "600",
                  height: "36px",
                  fontSize: "0.8125rem",
                }}
              >
                <i className="fa fa-file-excel" aria-hidden />
                XLS
                <i className="fa fa-download" style={{ fontSize: "0.7rem" }} aria-hidden />
              </button>
            </div>
          </div>

          {/* Table */}
          <div className="table-responsive">
            <table className="table mb-0" style={{ background: "#fff" }}>
              <thead>
                <tr>
                  {columns.map((col) => (
                    <ThCell key={col.key} col={col} />
                  ))}
                </tr>
              </thead>
              <tbody>
                {!hasData && (
                  <tr>
                    <td
                      colSpan={columns.length}
                      style={{
                        padding: "48px 24px",
                        background: "#fff",
                        borderBottom: "1px solid #e2e8f0",
                        verticalAlign: "middle",
                      }}
                    >
                      <div className="text-center" style={{ maxWidth: "400px", margin: "0 auto" }}>
                        <div style={{ marginBottom: "16px" }}>
                          <i className="fa fa-exclamation-triangle" style={{ fontSize: "3rem", color: "#f59e0b" }} aria-hidden />
                        </div>
                        <div style={{ color: "#0f172a", fontWeight: "600", fontSize: "1.0625rem", marginBottom: "6px" }}>
                          No data available.
                        </div>
                        <div style={{ color: "#64748b", fontSize: "0.875rem", lineHeight: 1.5 }}>
                          Tip: You could try again by selecting a different filter or date range.
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {selectedTxn && (
          <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content border-0 shadow" style={{ borderRadius: "12px" }}>
                <div className="modal-header border-0 pb-0">
                  <h5 className="modal-title" style={{ fontWeight: "600" }}>Transaction Details</h5>
                  <button type="button" className="btn-close" onClick={() => setSelectedTxn(null)} aria-label="Close" />
                </div>
                <div className="modal-body pt-2">
                  <p className="mb-2"><strong>Order ID:</strong> {selectedTxn.id}</p>
                  <p className="mb-2"><strong>Fund:</strong> {selectedTxn.fund}</p>
                  <p className="mb-2"><strong>Type:</strong> {selectedTxn.type}</p>
                  <p className="mb-2"><strong>Amount:</strong> ₹ {selectedTxn.amount}</p>
                  <p className="mb-2"><strong>Date:</strong> {selectedTxn.date}</p>
                  <p className="mb-0"><strong>Status:</strong> {selectedTxn.status}</p>
                </div>
                <div className="modal-footer border-0 pt-0">
                  <button type="button" className="btn btn-secondary" style={{ borderRadius: "8px" }} onClick={() => setSelectedTxn(null)}>Close</button>
                  <button type="button" className="btn text-white" style={{ background: TEAL, borderRadius: "8px" }}>Raise Ticket</button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
